
export function getScreensData(isMultiScreen) {
    var setMultiScreen = []
    // 由于https才能使用window.getScreenDetails()，目前只能通过传参形式模拟多屏操作

    // if (`getScreenDetails` in window) {
    //     let getScreensProsime1 = window.getScreenDetails()
    //     getScreensProsime1.then((c) => {
    //         if (c instanceof Array) {
    //             setMultiScreen.push(c)
    //         } else if (c instanceof Object) {
    //             _.forEach(c.screens, b => {
    //                 setMultiScreen.push(b)
    //             })
    //         } else {
    //             setMultiScreen.push([])
    //         }
    //     })
    //     return setMultiScreen
    // } else {
    //     if (isMultiScreen) {
    //         if (window.screen) {
    //             // 设置两块屏幕
    //             setMultiScreen.push(window.screen)
    //             setMultiScreen.push(window.screen)
    //         }
    //     }
    //     return setMultiScreen
    // }
    if (isMultiScreen) {
        if (window.screen) {
            // 设置两块屏幕
            setMultiScreen.push(window.screen)
            setMultiScreen.push(window.screen)
        }
    }
    return setMultiScreen
}
// 判断是否多屏幕
export function isMultiScreen(setMultiScreen) {
    if (setMultiScreen.length < 2) { return false } else { return true }
}
// 在其他屏幕打开新标签
export function openNewWindow(url, name, setMultiScreen) {
    let openWindow = null
    // 判断是否2个屏幕
    if (!window.screen && !window.getScreenDetails) {
        console.warn(`你的浏览器版本不支持多屏展示功能！`, 3)
        openWindow = window.open(url, name)
        return
    }
    if (setMultiScreen.length < 2) {
        console.warn(`请接入多个显示屏！`, 3)
        window.open(url, name)
    }
    let fulls = `screenX=0,top=0,screenY=0,scrollbars=1` // 定义弹出窗口的参数
    // 如果
    // 1. screen.availLeft 值是负数，主屏在右侧，当前屏幕是左侧副屏
    // 2. screen.availLeft 值是正数，主屏在左侧，当前屏幕是右侧副屏
    // 2. screen.availLeft 值是0，是主屏，左右屏幕下面方法判断
    if (Math.abs(screen.availLeft) >= screen.availWidth) {
        // 说明屏幕是副屏，直接设置0，到主屏
        fulls += `,left=0`
    } else if (screen.availLeft == 0) {
        // 主屏幕
        // 左侧主屏幕，右侧副屏幕直接left到右侧
        fulls += `,left=${screen.availWidth}`
    }

    let screenInfo = screen
    // 获取屏幕 宽高复制
    if (screenInfo) {
        // eslint-disable-next-line no-restricted-globals
        let ah = screenInfo.availHeight
        // eslint-disable-next-line no-restricted-globals
        let aw = screenInfo.availWidth
        fulls += `,height=${ah}`
        fulls += `,innerHeight=${ah}`
        fulls += `,width=${aw}`
        fulls += `,innerWidth=${aw}`
        fulls += `,resizable`
    } else {
        fulls += `,resizable` // 对于不支持screen属性的浏览器，可以手工进行最大化。 manually
    }
    openWindow = window.open(url, name, fulls)
    if (openWindow.screen.availLeft == 0) {
        // 右侧主屏幕，左侧侧副屏幕直接moveTo到左侧
        if (Math.abs(screen.availLeft) < screen.availWidth) {
            openWindow.moveTo(-`${screen.availWidth}`, 0)
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/OpenWindowExpand.js